import { getToken } from './utils';

export default function upload(option: any) {
  const { action, filename, file, onSuccess, onError } = option;
  const { token } = getToken();
  var myHeaders = new Headers();
  myHeaders.append('Authorization', token?.startsWith('Jwt') ? token : 'Jwt ' + token);

  var formdata = new FormData();
  formdata.append(filename, file);

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: formdata,
  };

  fetch(action, requestOptions)
    .then(async (response) => onSuccess(JSON.parse(await response.text())))
    .catch((error) => onError(error));
}
